import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';

import { MatDialogModule } from '@angular/material/dialog';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatMenuModule } from '@angular/material/menu';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatProgressBarModule} from '@angular/material/progress-bar';

import { BaseChartDirective } from 'ng2-charts'; 
import { ChartConfiguration, ChartData} from 'chart.js';

import { AnalysisOptionsComponent } from './../../tools/analysis-options/analysis-options.component';

//Variables del Navegador
type MenuItem = 'summary' | 'charts' ;

//Variable para expandir cada cuadro
interface ExpandedState {
  [key: string]: boolean;
}

interface WordCount {
  word: string;
  count: number;
}

interface Data {
  [key: string]: WordCount[];
}

interface DividedData {
  [key: string]: WordCount[][];
}

@Component({
  selector: 'awl-free',
  standalone: true,
  imports: [MatDialogModule,
    CommonModule,
    RouterOutlet,
    MatSidenavModule,
    MatExpansionModule,
    MatToolbarModule,
    MatIconModule,
    MatListModule,
    MatCardModule,
    MatButtonModule,
    MatInputModule,
    MatSelectModule,
    MatCheckboxModule,
    MatMenuModule,
    MatSlideToggleModule,
    MatProgressBarModule,
    AnalysisOptionsComponent,
    BaseChartDirective],
  templateUrl: './awl-free.component.html',
  styleUrl: './awl-free.component.css'
})
export class AwlFreeComponent {
  selectedMenuItem: MenuItem = 'summary';
  @Input() checked: boolean; //Variable del mat-slide-toggle del text-component

  activeEyeIcon: HTMLImageElement | null = null;

  //Valores para expandir cada Cuadro
  public isExpanded: ExpandedState = {
    AWL_T: false,
    AWL1: false,
    AWL2: false,
    AWL5: false,
    AWL7: false,
    AWL8: false,
    AWL9: false,
    K2: false,
    K3: false,
    K4: false,
    K5: false,
    UNLISTED: false
  };

  //Variables Pagina 1 Summary
  public datos_pagina_total={
    types:12,
    tokens:13,
  }

  public datos_pagina_AWL1={
    types:1,
    words:1,
    cumul_unique:0.4,
    cumul_words:0.3,
  }
  public datos_pagina_AWL2={
    types:3,
    words:3,
    cumul_unique:1.7,
    cumul_words:1.2,
  }
  public datos_pagina_AWL5={
    types:1,
    words:1,
    cumul_unique:2.1,
    cumul_words:1.5,
  }
  public datos_pagina_AWL7={
    types:2,
    words:3,
    cumul_unique:3.0,
    cumul_words:2.4,
  }
  public datos_pagina_AWL8={
    types:2,
    words:2,
    cumul_unique:3.8,
    cumul_words:3.0,
  }
  public datos_pagina_AWL9={
    types:3,
    words:3,
    cumul_unique:5.1,
    cumul_words:3.9,
  }
  public datos_pagina_K2={
    types:1,
    words:1,
    cumul_unique:5.5,
    cumul_words:4.2,
  }
  public datos_pagina_K3={
    types:3,
    words:3,
    cumul_unique:6.8,
    cumul_words:5.1,
  }
  public datos_pagina_K4={
    types:1,
    words:1,
    cumul_unique:7.3,
    cumul_words:5.4,
  }
  public datos_pagina_K5={
    types:1,
    words:1,
    cumul_unique:7.7,
    cumul_words:5.7,
  }
  public datos_pagina_unlisted={
    types:217,
    words:314,
    cumul_unique:null,
    cumul_words:null,
  }

  // Variables de la pagina de Summary
public types_total: number | undefined | null;
public tokens_total: number | undefined | null;

public types_AWL1: number | undefined | null;
public words_AWL1: number | undefined | null;
public cumul_types_AWL1: number | undefined | null;
public cumul_tokens_AWL1: number | undefined | null;

public types_AWL2: number | undefined | null;
public words_AWL2: number | undefined | null;
public cumul_types_AWL2: number | undefined | null;
public cumul_tokens_AWL2: number | undefined | null;

public types_AWL5: number | undefined | null;
public words_AWL5: number | undefined | null;
public cumul_types_AWL5: number | undefined | null;
public cumul_tokens_AWL5: number | undefined | null;

public types_AWL7: number | undefined | null;
public words_AWL7: number | undefined | null;
public cumul_types_AWL7: number | undefined | null;
public cumul_tokens_AWL7: number | undefined | null;

public types_AWL8: number | undefined | null;
public words_AWL8: number | undefined | null;
public cumul_types_AWL8: number | undefined | null;
public cumul_tokens_AWL8: number | undefined | null;

public types_AWL9: number | undefined | null;
public words_AWL9: number | undefined | null;
public cumul_types_AWL9: number | undefined | null;
public cumul_tokens_AWL9: number | undefined | null;

public types_K2: number | undefined | null;
public words_K2: number | undefined | null;
public cumul_types_K2: number | undefined | null;
public cumul_tokens_K2: number | undefined | null;

public types_K3: number | undefined | null;
public words_K3: number | undefined | null;
public cumul_types_K3: number | undefined | null;
public cumul_tokens_K3: number | undefined | null;

public types_K4: number | undefined | null;
public words_K4: number | undefined | null;
public cumul_types_K4: number | undefined | null;
public cumul_tokens_K4: number | undefined | null;

public types_K5: number | undefined | null;
public words_K5: number | undefined | null;
public cumul_types_K5: number | undefined | null;
public cumul_tokens_K5: number | undefined | null;

public types_unlisted: number | undefined | null;
public words_unlisted: number | undefined | null;
public cumul_types_unlisted: number | undefined | null;
public cumul_tokens_unlisted: number | undefined | null;

ngOnInit(): void {
  // Variables Pagina 1 WordList
  this.types_total = this.datos_pagina_total.types;
  this.tokens_total = this.datos_pagina_total.tokens;

  this.types_AWL1 = this.datos_pagina_AWL1.types;
  this.words_AWL1 = this.datos_pagina_AWL1.words;
  this.cumul_types_AWL1 = this.datos_pagina_AWL1.cumul_unique;
  this.cumul_tokens_AWL1 = this.datos_pagina_AWL1.cumul_words;

  this.types_AWL2 = this.datos_pagina_AWL2.types;
  this.words_AWL2 = this.datos_pagina_AWL2.words;
  this.cumul_types_AWL2 = this.datos_pagina_AWL2.cumul_unique;
  this.cumul_tokens_AWL2 = this.datos_pagina_AWL2.cumul_words;

  this.types_AWL5 = this.datos_pagina_AWL5.types;
  this.words_AWL5 = this.datos_pagina_AWL5.words;
  this.cumul_types_AWL5 = this.datos_pagina_AWL5.cumul_unique;
  this.cumul_tokens_AWL5 = this.datos_pagina_AWL5.cumul_words;

  this.types_AWL7 = this.datos_pagina_AWL7.types;
  this.words_AWL7 = this.datos_pagina_AWL7.words;
  this.cumul_types_AWL7 = this.datos_pagina_AWL7.cumul_unique;
  this.cumul_tokens_AWL7 = this.datos_pagina_AWL7.cumul_words;

  this.types_AWL8 = this.datos_pagina_AWL8.types;
  this.words_AWL8 = this.datos_pagina_AWL8.words;
  this.cumul_types_AWL8 = this.datos_pagina_AWL8.cumul_unique;
  this.cumul_tokens_AWL8 = this.datos_pagina_AWL8.cumul_words;

  this.types_AWL9 = this.datos_pagina_AWL9.types;
  this.words_AWL9 = this.datos_pagina_AWL9.words;
  this.cumul_types_AWL9 = this.datos_pagina_AWL9.cumul_unique;
  this.cumul_tokens_AWL9 = this.datos_pagina_AWL9.cumul_words;

  this.types_K2 = this.datos_pagina_K2.types;
  this.words_K2 = this.datos_pagina_K2.words;
  this.cumul_types_K2 = this.datos_pagina_K2.cumul_unique;
  this.cumul_tokens_K2 = this.datos_pagina_K2.cumul_words;

  this.types_K3 = this.datos_pagina_K3.types;
  this.words_K3 = this.datos_pagina_K3.words;
  this.cumul_types_K3 = this.datos_pagina_K3.cumul_unique;
  this.cumul_tokens_K3 = this.datos_pagina_K3.cumul_words;

  this.types_K4 = this.datos_pagina_K4.types;
  this.words_K4 = this.datos_pagina_K4.words;
  this.cumul_types_K4 = this.datos_pagina_K4.cumul_unique;
  this.cumul_tokens_K4 = this.datos_pagina_K4.cumul_words;

  this.types_K5 = this.datos_pagina_K5.types;
  this.words_K5 = this.datos_pagina_K5.words;
  this.cumul_types_K5 = this.datos_pagina_K5.cumul_unique;
  this.cumul_tokens_K5 = this.datos_pagina_K5.cumul_words;

  this.types_unlisted = this.datos_pagina_unlisted.types;
  this.words_unlisted = this.datos_pagina_unlisted.words;
  this.cumul_types_unlisted = this.datos_pagina_unlisted.cumul_unique;
  this.cumul_tokens_unlisted = this.datos_pagina_unlisted.cumul_words;
}

public data: Data = {
  AWL_T: [
    { word: "and", count: 6 },
    { word: "but", count: 6 },
    { word: "if", count: 1 },
    { word: "or", count: 1 },
    { word: "though", count: 3 },
    { word: "while", count: 3 },
  ],
  AWL1: [
    { word: "and", count: 6 },
    { word: "but", count: 6 },
    { word: "if", count: 1 },
    { word: "or", count: 1 },
    { word: "though", count: 3 },
    { word: "while", count: 3 },
  ],
  AWL2: [
    { word: "and", count: 6 },
    { word: "but", count: 6 },
    { word: "if", count: 1 },
    { word: "or", count: 1 },
    { word: "though", count: 3 },
    { word: "while", count: 3 },
  ],
  AWL5: [
    { word: "and", count: 6 },
    { word: "but", count: 6 },
    { word: "if", count: 1 },
    { word: "or", count: 1 },
    { word: "though", count: 3 },
    { word: "while", count: 3 },
  ],
  AWL7: [
    { word: "and", count: 6 },
    { word: "but", count: 6 },
    { word: "if", count: 1 },
    { word: "or", count: 1 },
    { word: "though", count: 3 },
    { word: "while", count: 3 },
  ],
  AWL8: [
    { word: "and", count: 6 },
    { word: "but", count: 6 },
    { word: "if", count: 1 },
    { word: "or", count: 1 },
    { word: "though", count: 3 },
    { word: "while", count: 3 },
  ],
  AWL9: [
    { word: "and", count: 6 },
    { word: "but", count: 6 },
    { word: "if", count: 1 },
    { word: "or", count: 1 },
    { word: "though", count: 3 },
    { word: "while", count: 3 },
  ],
  K2: [
    { word: "and", count: 6 },
    { word: "but", count: 6 },
    { word: "if", count: 1 },
    { word: "or", count: 1 },
    { word: "though", count: 3 },
    { word: "while", count: 3 },
  ],
  K3: [
    { word: "and", count: 6 },
    { word: "but", count: 6 },
    { word: "if", count: 1 },
    { word: "or", count: 1 },
    { word: "though", count: 3 },
    { word: "while", count: 3 },
  ],
  K4: [
    { word: "and", count: 6 },
    { word: "but", count: 6 },
    { word: "if", count: 1 },
    { word: "or", count: 1 },
    { word: "though", count: 3 },
    { word: "while", count: 3 },
  ],
  K5: [
    { word: "and", count: 6 },
    { word: "but", count: 6 },
    { word: "if", count: 1 },
    { word: "or", count: 1 },
    { word: "though", count: 3 },
    { word: "while", count: 3 },
  ],
  UNLISTED: [
    { word: "and", count: 6 },
    { word: "but", count: 6 },
    { word: "if", count: 1 },
    { word: "or", count: 1 },
    { word: "though", count: 3 },
    { word: "while", count: 3 },
  ],
  
  
};

//Dividir los datos obtenidos entre las 3 columnas al expandir la informacion

public dividedData: DividedData = {};


divideData() {
  for (const key in this.data) {
    if (this.data.hasOwnProperty(key)) {
      const items = this.data[key];
      const chunkSize = Math.ceil(items.length / 3);
      this.dividedData[key] = [
        items.slice(0, chunkSize),
        items.slice(chunkSize, chunkSize * 2),
        items.slice(chunkSize * 2),
      ];
    }
  }
}

//Funcion para expandir cada cuadro
toggleExpand(identifier: string) {
  this.isExpanded[identifier] = !this.isExpanded[identifier];
}

toggleExpandAll() {
  const newState = !this.isExpanded['AWL_T'] || !this.isExpanded['AWL1'] || !this.isExpanded['AWL2'] || !this.isExpanded['AWL5'] || !this.isExpanded['AWL7'] || !this.isExpanded['AWL8'] || !this.isExpanded['AWL9'] || !this.isExpanded['K2']|| !this.isExpanded['K3']|| !this.isExpanded['K4']|| !this.isExpanded['K5']|| !this.isExpanded['UNLISTED'];
  this.isExpanded['AWL_T'] = newState;
  this.isExpanded['AWL1'] = newState;
  this.isExpanded['AWL2'] = newState;
  this.isExpanded['AWL5'] = newState;
  this.isExpanded['AWL7'] = newState;
  this.isExpanded['AWL8'] = newState;
  this.isExpanded['AWL9'] = newState;
  this.isExpanded['K2'] = newState;
  this.isExpanded['K3'] = newState;
  this.isExpanded['K4'] = newState;
  this.isExpanded['K5'] = newState;
  this.isExpanded['UNLISTED'] = newState;
}

  constructor() {
    this.checked = true; 
    this.divideData();
  }

  selectMenuItem(menuItem: MenuItem) {
    this.selectedMenuItem = menuItem;
  }

  isSelected(menuItem: MenuItem): boolean {
    return this.selectedMenuItem === menuItem;
  }

  //Codigo para la Grafica
  public barChartOptions: ChartConfiguration<'bar'>['options'] = {
    scales: {
      x: {
        grid: {
          display: false,  // Ocultar las líneas verticales
        },
      },
      y: {
        min: 0,
        max: 25,  // Límite máximo del eje Y en 25%
        ticks: {
          stepSize: 5,  // Incrementos de 5% en 5%
          callback: function(value) {
            return value + '%';  // Mostrar el símbolo % en las etiquetas
          }
        },
        border: {
          display: false  // Eliminar el borde del eje Y
        },
        grid: {
          color: '#E0E0E0',  // Color de las líneas horizontales
        },
      },
    },
    plugins: {
      legend: {
        display: false, // Ocultar la leyenda
      },
      datalabels: {
              display: false // Desactiva los datalabels solo en este gráfico
            },
    },
  };
  
  
  public barChartType = 'bar' as const;
  
  public barChartData: ChartData<'bar'> = {
    labels: ['AWL1', 'AWL2', 'AWL5', 'AWL7', 'AWL8', 'AWL9','K2','K3','K4','K5'],
    datasets: [
      { 
        data: [20, 5, 3.5, 4, 2, 1,5,4,3.5,3.5,2],
        label: 'Knowledge Rank %',
        backgroundColor: [
          '#F60E17',  // Naranja
          '#C5C502',  // Verde
          '#8E8E5B',  // Rojo
          '#6C2D8E',  // Verde claro
          '#5BC52D',  // Azul
          '#0175FF',  // Púrpura
          '#2540F8',
          '#15622B',
          '#F75F1D',
          '#1A8583',
          
        ],
        // Hace las barras más delgadas
        barThickness: 40,
      },
    ],
  };

  //Para el cambio de color de los ojos
  toggleEyeIcon(event: Event): void {
    const element = event.target as HTMLImageElement;

    // Si hay un icono activo y no es el mismo que se hizo clic, restablecer su imagen
    if (this.activeEyeIcon && this.activeEyeIcon !== element) {
      this.activeEyeIcon.src = './assets/images/eye-icon.svg';
    }

    // Cambiar la imagen del icono actual
    if (element.src.includes('eye-icon.svg')) {
      element.src = './assets/images/yellow_icons/eye-on-icon.svg';
      this.activeEyeIcon = element; // Establecer el icono actual como activo
    } else {
      element.src = './assets/images/eye-icon.svg';
      this.activeEyeIcon = null; // No hay icono activo
    }
  }
}
